<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="props.width"
    :height="props.height"
    :viewBox="icon.viewBox"
    v-html="icon.content"></svg>
</template>
<script lang="ts">
import { defineComponent, reactive } from "vue";
import { IconContent } from "@/utility/icon";

export default defineComponent({
  props: {
    icon: {
      type: Object as () => IconContent,
      required: true,
    },
    width: String,
    height: String,
  },
  setup(prop) {
    const svgProps = reactive({
      width: prop.width ?? "1em",
      height: prop.height ?? "1em",
    });

    return {
      props: svgProps,
    };
  },
});
</script>
